// extracted by mini-css-extract-plugin
module.exports = {"sizedWrapper":"sizedWrapper_3zneEdQe","contentDisplay":"contentDisplay_V1naYuE2","imageDisplay":"imageDisplay_2zwUhUqQ","audioLoading":"audioLoading_pwH-COgA"};